import { gql } from "@apollo/client";
export const GET_NOTIFICATIONS_LIST = gql`
  query myNotificationsScroll(
    $first: Int
    $status: NotificationStatus
    $after: String
  ) {
    myNotificationsScroll(first: $first, status: $status, after: $after) {
      edges {
        cursor
        node {
          id
          title
          body
          actorName
          cardId
          panelScreen
          toUser {
            id
            firstName
            lastName
          }
          type
          createdAt
          toScreen
          dataId
          status
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        total
      }
    }
  }
`;

export const ARCHIVE_NOTIFICATION = gql`
  mutation archiveNotification($id: ID!) {
    archiveNotification(id: $id) {
      id
      status
    }
  }
`;

export const ARCHIVE_ALL_NOTIFICATION = gql`
  mutation archiveAllNotification {
    archiveAllNotification {
      isSuccess
    }
  }
`;

export const DELETE_NOTIFICATION = gql`
  mutation deleteNotification($id: ID!) {
    deleteNotification(id: $id) {
      isSuccess
    }
  }
`;

export const DELETE_ALL_NOTIFICATIONS = gql`
  mutation deleteAllNotification {
    deleteAllNotification {
      isSuccess
    }
  }
`;
